<script setup>
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

// Icons
import clockIcon from '@i/clock.svg';
import phoneIcon from '@i/phone.svg';

// Components
import Icon from '@/Components/Icon.vue';

const headerOpeningHours = computed(() => usePage().props.company_details.header_opening_hours);
const phoneNumber = computed(() => usePage().props.company_details.phone_number);
const showPhoneNumber = computed(() => usePage().props.template_options.header.show_phone_number);
const showOpeningHours = computed(() => usePage().props.template_options.header.show_opening_hours);
</script>

<template>
    <div class="min-h-10 bg-gray-lighter py-2">
        <div class="container flex justify-between">
            <div
                v-if="headerOpeningHours && showOpeningHours"
                class="hidden items-center gap-2 lg:flex"
            >
                <Icon
                    :icon="clockIcon"
                    :icon-dutch="clockIcon"
                    alt="phone icon"
                    class="h-auto w-3"
                />

                {{ headerOpeningHours }}
            </div>
            <div
                v-if="phoneNumber && showPhoneNumber"
                class="flex items-center gap-2"
            >
                <Icon
                    :icon="phoneIcon"
                    :icon-dutch="phoneIcon"
                    alt="phone icon"
                    class="h-auto w-3"
                />

                {{ phoneNumber }}
            </div>
        </div>
    </div>
</template>
